export { default } from './arrow-up'
